import firebase from "firebase";

export default class Auth
{
	signOut(onSuccess: Function)
	{
		firebase.auth().signOut().then
		(
			() =>
			{
				onSuccess();
			}
		);
	}

	signIn
	(
		email: string,
		password: string,
		onSuccess: (user: firebase.auth.UserCredential) => void,
		onError: Function
	)
	{
		firebase.auth().signInWithEmailAndPassword(email, password).then
		(
			(user) =>
			{
				onSuccess(user);
			},

			(err) =>
			{
				onError(err);
			}
		);
	}

	getCurrentUser(onSuccess: (user: firebase.User) => void, onError: Function)
	{
		firebase.auth().onAuthStateChanged((user) =>
		{
			if (user)
			{
				onSuccess(user);
			}
			else
			{
				onError();
			}
		});
	}

	getCurrentUserSync(): firebase.User | null
	{
		return firebase.auth().currentUser;
	}
}
